(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    const img = (card) => card.querySelector('slideshow-slide:not([hidden]) img');
    const show = (card, src) => {
      const el = img(card);
      if (!el || !src) return;
      if (!el.dataset.mgOrig) { el.dataset.mgOrig = el.src; el.dataset.mgOrigSet = el.srcset; }
      el.srcset = src === el.dataset.mgOrig ? el.dataset.mgOrigSet : '';
      el.src = src;
    };
    document.addEventListener('pointerover', (e) => {
      const l = e.target.closest?.('[data-mg-src]');
      if (l && e.pointerType === 'mouse') show(l.closest('product-card'), l.dataset.mgSrc);
    });
    document.addEventListener('pointerout', (e) => {
      const row = e.target.closest?.('product-swatches');
      if (!row || row.contains(e.relatedTarget) || e.pointerType !== 'mouse') return;
      const card = row.closest('product-card'), el = img(card);
      if (el) show(card, card.dataset.mgPicked || el.dataset.mgOrig);
    });
    document.addEventListener('click', (e) => {
      const l = e.target.closest?.('[data-mg-src]');
      if (!l) return;
      const card = l.closest('product-card');
      card.dataset.mgPicked = l.dataset.mgSrc;
      show(card, l.dataset.mgSrc);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
